import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { BracketedDiv, ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import { NotExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/NotExpression";

export class NotExpressionEditor extends ExpressionRuleEditor<NotExpression> {
    render() {
        return (
            <ExpressionPiece>
                not
                <BracketedDiv>
                    <ExpressionValueRenderer el={this.ruleData!.value1!} />
                </BracketedDiv>
            </ExpressionPiece>
        );
    }
}
